<template>
  <div>
    <el-dialog title="添加订单" :visible.sync="formVisible" :close-on-click-modal="false" top="3vh" width="1000px">
      <div v-loading="fullscreenLoading" class="content" :style="'height: ' + windowHeight + 'px; overflow-y: auto;'">
        <div class="reimbursement">
          <el-form ref="dataForm" :model="form" label-position="right" label-width="120px">
            <template>
              <el-form-item label="下单人信息：" prop="name" :rules="[{ required: true, message: '请选择', trigger: 'change' }]">
                <el-select v-model="form.name" value-key="value" placeholder="根据手机号/姓名搜索" filterable clearable remote :remote-method="searchUsers" :loading="loading" @change="getUserAddr">
                  <el-option v-for="(it,idx) in userList" :label="`${it.name}(${it.pho})${it.levelName}`" :key="idx" :value="it.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收货地址：" prop="addr" :rules="[{ required: true, message: '请选择收货地址', trigger: 'change' }]">
                <div class="flexs">
                  <el-select v-model="form.addr" placeholder="请选择收货地址" clearable>
                    <el-option v-for="(it,idx) in userAddrList" :key="idx" :label="it.allAddr" :value="it.id"></el-option>
                  </el-select>
                  <el-button type="primary" @click="addAddress">新增地址</el-button>
                </div>
              </el-form-item>
              <el-form-item label="随货同行单：" prop="companyName" :rules="[{ required: true, message: '请选择随货同行单', trigger: 'change' }]">
                <el-select v-model="form.companyName" placeholder="请选择随货同行单" clearable>
                  <el-option v-for="(it,idx) in customerCertificatesList" :key="idx" :label="it.companyName" :value="it.companyName"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="备注：" class="width100">
                <el-input v-model="form.msg" placeholder="请输入备注" />
              </el-form-item>
              <el-form-item label="支付方式：" prop="orderPayType" :rules="[{ required: true, message: '请选择支付方式', trigger: 'change' }]">
                <el-radio-group v-model="form.orderPayType" @input="changeRatio">
                  <el-radio :label="4">赠送支付<br /><span v-if="userWallet" class="pays">剩余：￥{{userWallet.tuition}}</span></el-radio>
                  <el-radio :label="1">零售价支付<br /><span v-if="userWallet" class="pays">剩余：￥{{userWallet.xiaoduMoney}}</span></el-radio>
                  <el-radio :label="2">余额支付<br /><span v-if="userWallet" class="pays">剩余：￥{{userWallet.balance}}</span></el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="优惠折扣：" class="width100">
                <el-input placeholder="优惠折扣" v-model="form.discount" @input="changeDiscount">
                  <template slot="append">折</template>
                </el-input>
              </el-form-item>
              <el-form-item v-if="showMixedPayment" label="混合支付折扣：" class="width100">
                <el-input placeholder="混合支付折扣" v-model="form.rmbBuyRatio" @input="changeMixedDiscount">
                  <template slot="append">折</template>
                </el-input>
              </el-form-item>
              <el-form-item label="订货商品：" class="width100">
                <div class="table-list mt20">
                  <div class="spec-head">
                    <div class="sp-col flex2">商品</div>
                    <div class="sp-col">规格</div>
                    <div class="sp-col">市场价</div>
                    <div class="sp-col"><span style="color:#F56C6C">*</span>折扣</div>
                    <div class="sp-col">数量</div>
                    <div class="sp-col">操作</div>
                  </div>
                  <div class="spec-item" v-for="(item, idx) in form.giftData" :key="idx">
                    <el-form-item class="sp-col flex2" label-width="0" :prop="`giftData[${idx}].goodsId`" :rules="{ required: true, message: '请选择', trigger: 'change' }">
                      <el-select v-model="item.goodsId" filterable placeholder="请选择" @change="handleChange(item)" :class="{'unmatched': item.isMatched === false}">
                        <el-option v-for="it in sysGoods" :key="it.id" :label="`${it.name}${it.aliasName ? ' [' + it.aliasName + ']' : ''}(${it.goodsCode})`" :value="it.id"></el-option>
                      </el-select>
                      <div v-if="item.isMatched === false" class="off-shelf-tip">已下架</div>
                    </el-form-item>
                    <el-form-item class="sp-col" :prop="`giftData[${idx}].skuId`" label-width="0" :rules="{ required: true, message: '请选择', trigger: 'change' }">
                      <span v-if="item.specArr && item.specArr.length === 1" class="spec-text">{{ item.productSpec || '无规格值' }}</span>
                      <el-select v-else v-model="item.skuId" placeholder="请选择规格" @change="handleSpecChange(item, idx)">
                        <el-option v-for="it in item.specArr" :key="it.id" :label="it.spec || '无规格值'" :value="it.id"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item class="sp-col" label-width="0" :rules="{
                        required: true,
                        message: '请填写',
                        trigger: 'change',
                      }">
                      <el-input v-model="item.price" placeholder="请输入商品价格" :disabled="true" />
                    </el-form-item>
                    <el-form-item class="sp-col" label-width="0" :rules="{
                        required: true,
                        message: '请填写',
                        trigger: 'change',
                      }">
                      <el-input v-model="item.discount" placeholder="请输入折扣" @input="getAllMoney" />
                    </el-form-item>
                    <el-form-item class="sp-col" :prop="`giftData[${idx}].buyNum`" label-width="0" :rules="[
                      {required: true, message: '请填写数量', trigger: 'change'},
                      {validator: validatePositiveInteger, trigger: 'blur'}
                    ]">
                      <el-input v-model="item.buyNum" placeholder="请输入数量" @input="getAllMoney" />
                    </el-form-item>
                    <div class="sp-col oper-icon">
                      <i class="el-icon-minus" @click="handleDeleteItem(idx)"></i>
                      <i class="el-icon-plus" @click="handleAddItem"></i>
                    </div>
                  </div>
                </div>
              </el-form-item>
              <div class="formMoney">商品总价：¥{{ form.allMoney }}</div>
              <el-form-item class="width100">
                <div class="formMoney">
                  <el-button type="primary" @click="getSendGoods">查询赠品</el-button>
                </div>
              </el-form-item>
              <div v-for="(item, index) in form.sendData" :key="index">
                <el-form-item label="赠品商品：" class="width100" :class="{ 'activity-eliminated': item.eliminated }">
                  <!-- REQ-2026-826259 #12⑤ 被择优淘汰的活动：灰显 + 写清原因，
                       让运营看得到"另一个活动存在过、只是没被选中" -->
                  <el-tag v-if="item.eliminated" size="mini" type="info">未选中</el-tag>
                  <span v-if="item.eliminated" class="eliminated-reason">{{ item.eliminatedReason }}</span>
                  {{item.activityName}}-
                  <span v-for="(itt,itdex) in item.activityConditionListVOS" :key="itdex">满{{itt.fullNum}}赠{{isVirtualReward(item) ? rewardAmountText(itt.rewardValue) : itt.giftNum}}{{item.activityConditionListVOS.length - 1 != itdex?'/':''}}</span>
                  <span v-if="isVirtualReward(item)" class="activity-gift-summary">-赠送{{virtualRewardLabel(item)}}{{rewardAmountText(item.finalRewardValue)}}</span>
                  <span v-else class="activity-gift-summary">-{{item.givingWay === 1 ? `随机赠送${randomGiftCount(item)}件` :  `自定义${giftLimit(item)}件`}}</span>
                  <span v-if="!isVirtualReward(item) && item.givingWay === 2 && !item.eliminated" class="gift-selection-count">（已选{{selectedGiftCount(item)}}件，还可选{{Math.max(0, giftLimit(item) - selectedGiftCount(item))}}件）</span>
                  <div class="table-list">
                    <div class="spec-head">
                      <div class="sp-col">赠品</div>
                      <div class="sp-col">{{isVirtualReward(item) ? '赠送金额' : '数量'}}</div>
                    </div>
                    <div v-if="isVirtualReward(item)" class="spec-item">
                      <div class="sp-col">{{virtualRewardLabel(item)}}</div>
                      <div class="sp-col">{{rewardAmountText(item.finalRewardValue)}}</div>
                    </div>
                    <div class="spec-item" v-for="(it, idx) in (isVirtualReward(item) ? [] : item.list)" :key="idx">
                      <el-form-item class="sp-col sp-col" label-width="0" :rules="{
                        required: true,
                        message: '请填写',
                        trigger: 'change',
                      }">
                        <span v-if="item.givingWay === 1">{{ it.goodsName }}</span>
                        <el-checkbox v-model="it.checked" v-else :disabled="item.eliminated" @change="(checked, event) => handleInput(it, item, event)">{{ it.goodsName }}</el-checkbox>
                      </el-form-item>
                      <el-form-item class="sp-col" label-width="0" :rules="{
                        required: true,
                        message: '请填写',
                        trigger: 'change',
                      }">
                        <span v-if="item.givingWay === 1">{{it.giftNum}}</span>
                        <el-input-number v-else v-model="it.buyNum" @change="handleChange1(it, item)" :step="1" step-strictly :min="0" :max="giftQuantityMax(item, it)" :disabled="!it.checked || item.eliminated"></el-input-number>
                        <!-- <el-input v-model="it.buyNum" :disabled="item.givingWay === 1" @input="handleInput(it, item)" placeholder="请输入数量" /> -->
                      </el-form-item>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <div class="frBox">
                <el-form-item label="快递类型：" class="width50" prop="expressId" :rules="[{ required: true, message: '请选择快递类型', trigger: 'change' },]">
                  <el-select v-model="form.expressId" placeholder="请选择快递类型" clearable @change="changeExpress">
                    <el-option v-for="(it,idx) in deliveryList" :key="idx" :label="it.name" :value="it.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="邮费：" class="width50" prop="freight" :rules="[
                  { required: true, message: '请填写邮费', trigger: 'blur' },
                  { validator: validateFreight, trigger: 'blur' }
                ]">
                  <el-input v-model="form.freight" placeholder="请输入邮费" :disabled="!form.expressId" @blur="formatFreightOnBlur" />
                </el-form-item>
              </div>

            </template>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取消</el-button>
            <el-button type="primary" @click="doCreate()" :disabled="isSubmitDisabled">确定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <addressVue ref="addressVue" @created="createAddr" />
  </div>
</template>
<script>
import goodsOrderApi from "@/api/order/goodsOrder";
import sysGoodsApi from "@/api/sys/sysGoods";
import { Subtr, accMul, formatDateStr, getDateAfterNDays } from "@/utils/index";
import addressVue from './address.vue'
import { isVirtualReward, virtualRewardLabel, rewardAmountText, hasVirtualRewardAmount } from '@/utils/activityVirtualRewards'
function initFormBean() {
  const formBean = {
    discount: undefined,
    rmbBuyRatio: undefined, // 添加混合支付折扣字段
    giftData: [{ goodsId: "", skuId: "", buyNum: "", price: "", discount: '' }],
    sendData: [],
    allMoney: 0,
    name: undefined,
    addr: undefined,
    companyName: undefined,
    msg: undefined,
    expressId: undefined,
    freight: undefined,
  }
  return formBean
}
export default {
  components: { addressVue },
  data() {
    return {
      deliveryList: [],
      userList: [],
      userAddrList: [],
      customerCertificatesList: [],
      sysGoods: [],
      form: initFormBean(),
      formVisible: false,
      fullscreenLoading: false,
      isRepSub: false,
      userWallet: null,
      showMixedPayment: false, // 添加控制混合支付折扣显示的变量
      loading: false, // 添加loading属性用于el-select的loading状态
    };
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 150;
    this.getDeliveryList();
    // this.getUserList();
    this.getGoods();

  },
  computed: {
    // 添加计算属性来判断确定按钮是否应该禁用
    isSubmitDisabled() {
      if (!this.userWallet || !this.form.orderPayType) {
        return false;
      }
      
      const { orderPayType } = this.form;
      const { tuition, xiaoduMoney } = this.userWallet;
      
      // 如果是赠送支付且余额为0，禁用按钮
      if (orderPayType === 4 && parseFloat(tuition) <= 0) {
        return true;
      }
      
      // 如果是零售价支付且余额为0，禁用按钮
      if (orderPayType === 1 && parseFloat(xiaoduMoney) <= 0) {
        return true;
      }
      
      return false;
    }
  },
  methods: {
    // 添加方法判断支付方式是否应该禁用
    isPaymentDisabled(payType) {
      if (!this.userWallet) {
        return false;
      }
      
      const { tuition, xiaoduMoney } = this.userWallet;
      
      // 赠送支付且余额为0时禁用
      if (payType === 4 && parseFloat(tuition) <= 0) {
        return true;
      }
      
      // 零售价支付且余额为0时禁用
      if (payType === 1 && parseFloat(xiaoduMoney) <= 0) {
        return true;
      }
      
      return false;
    },
    changeMixedDiscount() {
      // 混合支付折扣变化时的处理逻辑
      this.getAllMoney()
    },
    // 检查是否需要显示混合支付折扣
    checkMixedPayment() {
      if (!this.userWallet || !this.form.orderPayType || !this.form.allMoney) {
        this.showMixedPayment = false;
        return;
      }

      let { orderPayType, allMoney, freight } = this.form;
      let { tuition, xiaoduMoney, balance } = this.userWallet;
      let availableAmount = orderPayType === 1 ? xiaoduMoney : (orderPayType === 2 ? balance : tuition);
      let totalAmount = parseFloat(allMoney) + parseFloat(freight || 0);

      this.showMixedPayment = parseFloat(availableAmount) < parseFloat(totalAmount);
    },
    validatePositiveInteger(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        callback(new Error('请填写数量'));
      } else if (!/^[1-9]\d*$/.test(value)) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    },
    validateFreight(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        return callback(new Error('请填写邮费'))
      }
      const num = Number(value)
      if (isNaN(num) || num < 0) {
        return callback(new Error('邮费需≥0，保留2位小数'))
      }
      // 必须保留2位小数
      const str = String(value)
      if (!/^\d+(\.\d{2})$/.test(str)) {
        return callback(new Error('邮费需≥0，保留2位小数'))
      }
      callback()
    },
    formatFreightOnBlur() {
      if (this.form.freight === '' || this.form.freight === null || this.form.freight === undefined) return
      const num = Number(this.form.freight)
      if (!isNaN(num) && num >= 0) {
        this.form.freight = num.toFixed(2)
      }
    },
    changeDiscount() {
      this.form.giftData.forEach(item => {
        item.discount = this.form.discount
      })
      this.getAllMoney()
    },
    addAddress() {
      if (!this.form.name) return this.$message('请选择下单人')
      let find = this.userList.find(item => item.id === this.form.name)
      this.$refs.addressVue.handleShow(find)
    },
    createAddr(id) {
      this.getUserAddr(id)
    },
    isVirtualReward,
    virtualRewardLabel,
    rewardAmountText,
    giftLimit(item) {
      const amount = Number(item.finalGiftNum)
      return Number.isSafeInteger(amount) && amount >= 0 ? amount : 0
    },
    randomGiftCount(item) {
      if (item.finalGiftNum !== null && item.finalGiftNum !== undefined) return this.giftLimit(item)
      return (item.list || []).reduce((sum, row) => sum + (Number(row.giftNum) || 0), 0)
    },
    selectedGiftCount(item, except) {
      return (item.list || []).reduce((sum, row) => {
        const count = Number(row.buyNum)
        return sum + (row !== except && row.checked && Number.isSafeInteger(count) && count > 0 ? count : 0)
      }, 0)
    },
    giftQuantityMax(item, row) {
      return Math.max(0, this.giftLimit(item) - this.selectedGiftCount(item, row))
    },
    warnGiftLimit(item) {
      this.$message.warning(`「${item.activityName || '该活动'}」最多可选${this.giftLimit(item)}件赠品`)
    },
    handleChange1(it, item) {
      if (item.givingWay !== 2 || !it.checked) return
      const count = Number(it.buyNum)
      const remaining = this.giftQuantityMax(item, it)
      if (!Number.isSafeInteger(count) || count < 0) {
        this.$set(it, 'buyNum', 0)
        this.$message.warning('赠品数量请输入0或正整数')
      } else if (count > remaining) {
        this.$set(it, 'buyNum', remaining)
        this.warnGiftLimit(item)
      }
    },
    handleInput(it, item, event) {
      if (item.givingWay !== 2 || !it.checked) return
      const remaining = this.giftQuantityMax(item, it)
      if (!remaining) {
        this.$set(it, 'checked', false)
        // Vue2 skips checked DOM patches when a same-tick rollback leaves the
        // old/new VDOM value false. Keep the native toggle aligned for the next click.
        if (event && event.target) event.target.checked = false
        this.warnGiftLimit(item)
        return
      }
      const count = Number(it.buyNum)
      const wanted = Number.isSafeInteger(count) && count > 0 ? count : 1
      this.$set(it, 'buyNum', Math.min(wanted, remaining))
      if (wanted > remaining) this.warnGiftLimit(item)
    },
    validateSelectedGifts() {
      for (const item of this.form.sendData) {
        if (!item.eliminated && isVirtualReward(item)) {
          if (!hasVirtualRewardAmount(item)) {
            this.$message.warning('虚拟赠品金额待确认，请重新查询赠品')
            return false
          }
          continue
        }
        if (item.eliminated || item.givingWay !== 2) continue
        if (this.selectedGiftCount(item) > this.giftLimit(item)) {
          this.warnGiftLimit(item)
          return false
        }
        if ((item.list || []).some(row => row.checked && (!Number.isSafeInteger(Number(row.buyNum)) || Number(row.buyNum) <= 0))) {
          this.$message.warning('已选赠品的数量必须为正整数')
          return false
        }
        if (this.selectedGiftCount(item) < this.giftLimit(item)) {
          this.$message.warning(`「${item.activityName || '该活动'}」赠品未选足，需选择${this.giftLimit(item)}件，已选择${this.selectedGiftCount(item)}件`)
          return false
        }
      }
      return true
    },
    getUserWallet() {
      goodsOrderApi.userWallet(this.form.name).then(res => {
        this.userWallet = res.data
        this.checkMixedPayment() // 添加检查混合支付
      })
    },
    resetForm() {
      this.isRepSub = false
      this.userWallet = null
      this.form = initFormBean()
    },
    getDeliveryList(row) {
      let orderType = "1";
      goodsOrderApi.getDeliveryList({ orderType, isEnable: 1 }).then((res) => {
        let { list } = res.data;
        this.deliveryList = list;
      });
    },
    searchUsers(query) {
      if (query !== '') {
        this.loading = true;
        // 模拟远程搜索，实际应用中应该是发起AJAX请求
        setTimeout(() => {
          this.loading = false;
          this.getUserList(query)
        }, 500);
      } else {
        this.options = [];
      }
    },
    getUserList(query) {
      goodsOrderApi.getUserList({ state: 1, isDeparted: 0, filterNotCertified: 1, nameOrPho: query, pageNo: 1, pageSize: 100 }).then((res) => {
        let { list } = res.data;
        let arr = []
        list && list.forEach(item => {
          let { id, name, pho, userId } = item.customer;
          arr.push({ id, name, pho, userId, levelName: item.customerLevel.name })
        })
        this.userList = arr;
      });
    },
    changeExpress() {
      let { expressId, addr, allMoney, orderPayType } = this.form;
      if (expressId && addr && allMoney && orderPayType) {
        goodsOrderApi.freight({ expressId, addressId: addr, money: allMoney, payType: orderPayType }).then(res => {
          this.form.freight = Number(res.data).toFixed(2);
          this.checkMixedPayment() // 添加检查混合支付
        })
      }
    },
    handleCreate(row) {
      this.resetForm()
      if (row && row.id) this.clacCopyOrder(row)
      this.formVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    //复制订单
    clacCopyOrder(row) {
      goodsOrderApi.getGoodsList({ orderId: row.id, pageSize: 1000 }).then(res => {
        let { list } = res.data, goodList = [];
        if (list.length > 0) {
          list.forEach((item, idx) => {
            let { goodsId, combineId, combineCount, goodsPrice } = item
            let find = this.sysGoods.find((it) => it.id === item.goodsId);
            // 添加标记，用于判断是否匹配上数据
            let isMatched = !!find;
            item.sendDay = find ? find.sendDay : ''
            let specArr = find ? find.specValueList : []
            let findspec = find ? find.specValueList.find(it => it.id === combineId) : null
            let price = findspec ? findspec.retailPrice : 0;
            let presell = findspec ? (findspec.surplusStock <= 0 ? 1 : 0) : 0;
            let presellTime = findspec ? (find.sendDay && findspec.surplusStock <= 0 ? formatDateStr(getDateAfterNDays(item.sendDay)) : '') : '';
            goodList.push({
              goodsId,
              specArr,
              // REQ-2026-234328 产品规格优先，回退老的自由文本「商品规格」——
              // product_spec 没有存量回填，只取新字段会让历史商品这一栏空白
              productSpec: find ? (find.productSpec || find.spec) : '',
              sendDay: find && find.sendDay,
              presell,
              presellTime,
              skuId: combineId,
              buyNum: combineCount,
              price,
              discount: this.form.discount,
              isMatched // 添加匹配标记
            })
          })
          this.form.giftData = goodList;
        }
      })
    },
    // 选择事件
    getUserAddr(val) {
      let find = this.userList.find(item => item.id === val)
      goodsOrderApi.getUserAddrList({ userId: find.userId }).then((res) => {
        let { list } = res.data;
        if (list.length) {
          list.forEach((it) => {
            it.allAddr = it.country + it.province + it.city + it.district + it.detailedAddress;
          });
        }
        this.userAddrList = list;
      });
      goodsOrderApi.getCustomerCertificatesList(val).then((res) => {
        this.customerCertificatesList = res.data;
        this.form.addr = undefined;
      });
      this.changeRatio()
      this.getUserWallet()
    },
    changeRatio() {
      this.changeExpress()
      let { orderPayType, name } = this.form;
      if (orderPayType && name) {
        // 1零售价2余额4赠送
        goodsOrderApi.profitRatioCust({ custId: name, payType: orderPayType }).then(res => {
          if (res.data) {
            let dis = accMul(res.data, 10)
            this.form.discount = dis;
            this.form.giftData.forEach(item => {
              item.discount = dis
            })
            this.getAllMoney()
            this.checkMixedPayment() // 添加检查混合支付
          }
        })
        goodsOrderApi.profitRatioCust({ custId: name, payType: 2 }).then(res => {
          if (res.data) {
            let dis = accMul(res.data, 10)
            this.form.rmbBuyRatio = orderPayType === 2 ? 10 : dis; // 设置混合支付折扣
          }
        })
      }
    },
    getGoods() {
      sysGoodsApi.getGoodRecomList({ isListing: 1 }).then(({ data }) => {
        this.sysGoods = data;
      });
    },
    handleChange(item) {
      let find = this.sysGoods.find((it) => it.id === item.goodsId);
      // 更新匹配状态
      item.isMatched = !!find;
      item.sendDay = find ? find.sendDay : ''
      item.specArr = find ? find.specValueList : []
      // REQ-2026-234328 产品规格优先，回退老的自由文本「商品规格」
      item.productSpec = find ? (find.productSpec || find.spec) : ''
      let id = find && find.specValueList.length === 1 ? find.specValueList[0].id : null
      if (id) {
        item.price = find.specValueList[0].retailPrice;
        item.presell = find.specValueList[0].surplusStock <= 0 ? 1 : 0;
        item.presellTime = item.sendDay && find.specValueList[0].surplusStock <= 0 ? formatDateStr(getDateAfterNDays(item.sendDay)) : '';
      }
      this.$set(item, "skuId", id);
      this.getAllMoney()
    },
    handleSpecChange(item, index) {
      item.specArr.forEach((it, idx) => {
        console.log(1111, it, item)
        if (it.id == item.skuId) {
          this.form.giftData[index].price = it.retailPrice;
          this.form.giftData[index].presell = it.surplusStock <= 0 ? 1 : 0;
          this.form.giftData[index].presellTime = item.sendDay && it.surplusStock <= 0 ? formatDateStr(getDateAfterNDays(item.sendDay)) : '';
        }
      });
      this.getAllMoney()
    },
    handleDeleteItem(index) {
      if (this.form.giftData.length <= 1) return;
      this.form.giftData.splice(index, 1);
      this.getAllMoney()
    },
    handleAddItem() {
      this.form.giftData.push({
        goodsId: "",
        skuId: "",
        buyNum: "",
        price: "",
        discount: this.form.discount,
      });
    },
    getAllMoney() {
      let allMoney = 0;
      this.form.giftData.forEach((it) => {
        if (it.buyNum && it.price && it.discount) {
          allMoney = Subtr(
            allMoney,
            -accMul(it.buyNum, accMul(it.price, it.discount * 0.1))
          );
        }
      });
      this.form.allMoney = parseFloat(allMoney).toFixed(2);
      this.changeExpress()
      this.checkMixedPayment() // 添加检查混合支付
    },
    // REQ-2026-228632 ③（测试单 169）：总价只在折扣填了才算，折扣没填时 allMoney 是 0，
    // 「查询赠品」和「确定」都会静默拒绝，测试以为按钮坏了。这里把"哪一行没填折扣"说出来。
    missingDiscountRows() {
      return this.form.giftData.filter(it => it.buyNum && !(it.discount && Number(it.discount) > 0))
    },
    activityPayMode() {
      return { 1: 'XIAODUBI', 2: 'BALANCE', 4: 'GIFT' }[this.form.orderPayType]
    },
    getSendGoods() {
      let { name, allMoney, orderPayType } = this.form;
      if (!name) return this.$message("请选择用户");
      if (this.missingDiscountRows().length) return this.$message.warning("请先填写每个商品的折扣（必填）");
      if (!allMoney) return this.$message("请选择订货商品");
      if (!orderPayType) return this.$message("请选择支付方式");
      let settleGoodsDtos = [];
      this.form.giftData.forEach((it) => {
        if (it.buyNum && it.discount) {
          var obj = {
            buyNum: it.buyNum,
            goodsId: it.goodsId,
            price: it.price,
            skuId: it.skuId,
          };
          settleGoodsDtos.push(obj);
        }
      });
      // settleGoodsDtos = JSON.stringify(settleGoodsDtos)
      let query = {
        customerId: name,
        settleGoodsDtos,
        orderPayType,
        payMode: this.activityPayMode(),
        goodsType: orderPayType === 1 ? 2 : (orderPayType === 2 ? 1 : 3)
      };
      goodsOrderApi.getSendGoodsList(query).then(({ data }) => {
        // REQ-2026-826259 #12⑤：**被择优淘汰的活动也要留在列表里**（后端已改成打标不过滤）。
        // 以前直接 filter 掉，运营看到的是"只有一个活动"，不知道另一个存在过，
        // 客户问"为什么没按那个送"时答不上来。
        // 这里仍然只保留命中的（canSend===1）—— 没命中的活动本来就不该出现在这一屏。
        this.form.sendData = data.filter(item => item.canSend === 1).map(item => {
          if (isVirtualReward(item) || item.givingWay !== 2) return item
          // Every quote starts a fresh selection. A missing checked value makes
          // a reused ElCheckbox fall back to its previous selfModel instead of
          // the new quote. Define both UI fields before Vue observes the rows.
          return { ...item, list: (item.list || []).map(row => ({ ...row, checked: false, buyNum: 0 })) }
        });
      });
    },
    // 添加订单
    doCreate() {
      if (this.fullscreenLoading) return;
      if (!this.validateSelectedGifts()) return;
      // 添加余额检查
      if (this.isSubmitDisabled) {
        const { orderPayType } = this.form;
        const { tuition, xiaoduMoney } = this.userWallet;
        
        if (orderPayType === 4 && parseFloat(tuition) <= 0) {
          this.$message.error('赠送支付余额不足，无法提交订单');
          return;
        }
        
        if (orderPayType === 1 && parseFloat(xiaoduMoney) <= 0) {
          this.$message.error('零售价余额不足，无法提交订单');
          return;
        }
      }
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          // 检查是否有未匹配的商品
          const unmatchedGoods = this.form.giftData.filter(item => item.isMatched === false);
          if (unmatchedGoods.length > 0) {
            this.$message.error('存在已下架的商品数据，请重新选择商品');
            return;
          }

          let { orderPayType, allMoney, freight } = this.form;
          let { tuition, xiaoduMoney, balance } = this.userWallet;
          let price = orderPayType === 1 ? xiaoduMoney : (orderPayType === 2 ? balance : tuition)
          let allAmount = Subtr(allMoney, -freight)
          if (+price < +allAmount) {
            this.$alert('订单未支付，当前客户余额/零售价/赠送账户不足，请提示客户！', '', {
              confirmButtonText: '知道了',
              callback: action => {
                this.submitForm()
              }
            });
          } else {
            this.submitForm()
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    checkHintOrder() {
      this.$confirm(`<p style="color: red;">请仔细核对以下价格，确认无误后再生成订单！</p>
      <p>商品原价：元</p>
      <p style="color: red;">折扣金额：元</p>
      <p>商品支付金额：元</p>
      <p>邮费支付金额：元</p>
      <p style="color: red;">支付总金额：元</p>`, '支付价格明细提示', {
        dangerouslyUseHTMLString: true,
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.submitForm()
      })
    },
    submitForm() {
      if (!this.validateSelectedGifts()) return;
      let settleGoodsDtos = [];
      this.form.giftData.forEach((it) => {
        if (it.buyNum && it.discount) {
          var obj = {
            buyNum: it.buyNum,
            goodsId: it.goodsId,
            price: it.price,
            skuId: it.skuId,
            presell: it.presell,
            presellTime: it.presellTime,
          };
          settleGoodsDtos.push(obj);
        }
      });
      let sendSettleGoodsDtos = [];
      if (this.form.sendData.length > 0) {
        this.form.sendData.filter(item => !item.eliminated && !isVirtualReward(item) && item.givingWay === 2).forEach((item) => {
          item.list.forEach((it) => {
            if (it.checked && it.buyNum) {
              var obj = {
                activityId: item.activityId,
                buyNum: it.buyNum,
                goodsId: it.productId,
                skuId: it.id,
              };
              sendSettleGoodsDtos.push(obj);
            }
          });
        });
      }
      let query = {
        addressId: this.form.addr,
        customerId: this.form.name,
        customerIdcard: this.form.companyName,
        expressId: this.form.expressId,
        orderRemark: this.form.msg,
        profitRatio: this.form.discount / 10,
        rmbBuyRatio: this.form.rmbBuyRatio / 10,
        freight: this.form.freight,
        orderPayType: this.form.orderPayType,
        payMode: this.activityPayMode(),
        goodsType: this.form.orderPayType === 1 ? 2 : (this.form.orderPayType === 2 ? 1 : 3),
        settleGoodsDtos,
        sendSettleGoodsDtos,
      };
      if (this.isRepSub) return
      this.isRepSub = true
      this.fullscreenLoading = true;
      goodsOrderApi.addHouOrder(query).then((res) => {
        if (res) {
          this.fullscreenLoading = false;
          this.formVisible = false;
          this.$alert('订单未支付，请提示客户先前往app支付！', '', {
            confirmButtonText: '知道了',
            callback: action => {
              this.$emit("created");
              this.isRepSub = false
            }
          });
        }
      }).catch(res => {
        this.fullscreenLoading = false;
        this.isRepSub = false
      });
    },
    closeDialog() {
      this.formVisible = false;
      this.fullscreenLoading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
/* REQ-2026-826259 #12⑤ 被择优淘汰的活动：整块灰显。
   **只降低视觉权重、不隐藏** —— 隐藏就退回改造前那个"静默消失"的问题了。 */
.activity-eliminated {
  opacity: 0.55;
}
.eliminated-reason {
  margin-left: 6px;
  color: #909399;
  font-size: 12px;
}
.mt {
  margin-top: 10px;
}
.reimbursement {
  padding: 0 20px;
}
.dialog-footer {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  padding: 10px 0;
}
.reimbursement {
  // padding: 0 20px;
}
.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 6px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}
.table-list {
  border: 1px solid #e4e4e4;

  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;

    &.flex2 {
      flex-grow: 2;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #5dbde7;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
       
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.item-flex {
  display: flex;
  margin-bottom: 5px;
  .icon-box {
    display: inline-block;
    width: 60px;
    i {
      font-size: 20px;
      margin-left: 5px;
      cursor: pointer;
      font-weight: bold;
      color: #465c99;
    }
  }
}
.oper-icon {
  i {
    font-size: 16px;
    margin-left: 5px;
    cursor: pointer;
    font-weight: bold;
    color: #465c99;
  }
}
.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}
.hint {
  font-size: 12px;
  color: #878787;
  &.hint1 {
    padding-left: 10px;
    line-height: 18px;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-left: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}
.title-box {
  margin-bottom: 10px;
  margin-right: 24px;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 30px;
    &::before {
      content: '';
      position: absolute;
      left: 20px;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
    cursor: pointer;
  }
}
.table-list {
  border: 1px solid #e4e4e4;
  // margin: 0 35px 20px 50px;
  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;

    &.flex2 {
      flex-grow: 2;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #f9fafc;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.frBox {
  display: flex;
  align-items: center;
  .width50 {
    width: 50% !important;
  }
}
::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 10px;
}
.formMoney {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: 20px;
  color: #e73f3f;
  .el-button {
    margin-top: 20px;
  }
}
.pays {
  font-size: 10px;
  color: #999;
}
.is-checked .pays {
  color: #999;
}
.select-wrapper {
  position: relative;
  width: 100%;
}

.off-shelf-tip {
  color: #f56c6c;
  font-size: 12px;
  position: absolute;
  left: 8px;
  bottom: -12px;
}

::v-deep .unmatched {
  .el-input__inner {
    border-color: #f56c6c;
  }
}
</style>
